/**
 * Operational kill switches for voice capture/providers (Voice_TODO Section 9).
 * Disable capture UI and cloud/provider calls only — never weaken auth or confirmation.
 */

function envTrue(name: string): boolean {
  return process.env[name] === 'true';
}

/** Hide/no-op voice capture UI and microphone start. */
export function isVoiceCaptureUiDisabled(): boolean {
  return envTrue('REACT_APP_VOICE_CAPTURE_UI_DISABLED');
}

/** Block client calls to cloud transcription endpoints. */
export function isVoiceCloudTranscriptionDisabled(): boolean {
  return envTrue('REACT_APP_VOICE_CLOUD_TRANSCRIPTION_DISABLED');
}

/** Skip live OpenAI Realtime transcription (recorded-upload transcription still works). */
export function isVoiceRealtimeTranscriptionDisabled(): boolean {
  return isVoiceCloudTranscriptionDisabled() || envTrue('REACT_APP_VOICE_REALTIME_TRANSCRIPTION_DISABLED');
}

/** Block client calls to cloud TTS providers (browser TTS may remain). */
export function isVoiceTtsProviderDisabled(): boolean {
  return envTrue('REACT_APP_VOICE_TTS_PROVIDER_DISABLED');
}
